export default __webpack_public_path__ + "static/media/guide-img-4.6d07bbd8.png";